export const en = {
    "create-alice-skill": "Create Alice skill",
    "create-auto-app": "Create Auto application",
    "create-smart-home": "Create Smart home",
    "create-smart-screen-app": "Create Duo application",
    "create-tv-app": "Create TV application",
    "applications": "Applications",
    "published-version": "Published version",
    "new-version": "New version",
    "new-app": "New application",

    "main-information": "Main Information",
    "about-application": "About Application",
    "application": "Application",
    "assets": "Assets",
    "agreements": "Agreements",
    "feature-flags": "Feature Flags",
    "analytics": "Analytics",
    "feedback": "Feedback",
    "docs": "Documentation",
    "yandex-copyright": "©2024 Yandex LLC"
} as const;
export const ru = {
    "create-alice-skill": "Создать навык Алисы",
    "create-auto-app": "Создать Авто приложение",
    "create-smart-home": "Создать Умный дом",
    "create-smart-screen-app": "Создать Duo приложение",
    "create-tv-app": "Создать ТВ приложение",
    "applications": "Приложения",
    "published-version": "Опубликованная версия",
    "new-version": "Новая версия",
    "new-app": "Новое приложение",

    "main-information": "Основная информация",
    "about-application": "О приложении",
    "application": "Приложение",
    "assets": "Ресурсы",
    "agreements": "Соглашения",
    "feature-flags": "Фича-флаги",
    "analytics": "Аналитика",
    "feedback": "Обратная связь",
    "docs": "Документация",
    "yandex-copyright": "© 2024 ООО «Яндекс»"
} as const;
